'use client'
import type { FC } from 'react'
import styled from 'styled-components'
import { useTranslator } from '@/hooks'
import type { TypeValidCatalogSlugs } from '@/app/[lang]/(public)/catalog/detail/[slug]/page'
import { CatalogCard } from './project/CatalogCard'
import { slugify } from '@/utils'
import type { TypeCmsSection } from '@/schema'
import { mq, presetsFluid, rgbAlpha, vw } from '@/styles'

type Props = {
  data?: TypeCmsSection
  slug: TypeValidCatalogSlugs
}

const headingId = 'catalog-sections-list'
export const SectionCatalogDetailList:FC<Props> = ({ data, slug }) => {
  const { groups = [] } = data || {}
  const { t } = useTranslator()
  return (
    <Section aria-labelledby={headingId}>
      <hgroup>
        <h2 id={headingId}>{t(`project.catalog_detail.${slug}.section_categories.title`)}</h2>
      </hgroup>
      <ul>
        {groups.map((cat, index) => <CatalogCard key={`${index}-${slugify(cat.name)}`} data={cat} type='category' />)}
      </ul>
    </Section>
  )
}

const Section = styled.section`
  align-items: flex-start;
  border-top: 1px solid ${rgbAlpha('--color-text', .2)};
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: var(--viewport-width);
  width: var(--viewport-width--dynamic);

  ${mq.greaterThan('tablet')} {
    flex-direction: row;
  }

  hgroup {
    display: none;

    ${mq.greaterThan('tablet')} {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      padding: ${vw(30, 'desktop')};
      width: var(--viewport-width-quarter);
      width: var(--viewport-width-quarter--dynamic);
    }

    ${mq.greaterThan('desktop')} {
      padding: 30px ${vw(30, 'desktop')};
    }
  }

  h2 {
    ${presetsFluid.font28_40()}
    font-weight: 300;
    text-align: left;

		${mq.greaterThan('desktop')} {
			${presetsFluid.font40_rel()}
		}
  }

  ul {
    display: flex;
    flex-wrap: wrap;

    ${mq.greaterThan('tablet')} {
      border-left: 1px solid ${rgbAlpha('--color-text--light', .2)};
      width: var(--viewport-width-three-quarter);
      width: var(--viewport-width-three-quarter--dynamic);
    }
  }
`
